module.exports = __webpack_public_path__ + "assets/img/num-01-02905573.png";